import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { projectIdSelector } from 'reducers/router/selectors';
import { setActiveProjectId, validateProjectId } from 'actions/projects';

const ActiveProjectSetup = ({ children }) => {
  const dispatch = useDispatch();
  const projectId = useSelector(projectIdSelector);

  useEffect(() => {
    if (!projectId) {
      return;
    }

    dispatch(setActiveProjectId(projectId));
    dispatch(validateProjectId());
  }, [projectId, dispatch]);

  return children;
};

ActiveProjectSetup.propTypes = {
  children: PropTypes.node.isRequired
};

export default ActiveProjectSetup;
